<template>
  <div class="wh-screen">
    <global-confirm-box ref="confirmBox" />
    <warehouse-waybill-dialog v-model="waybillDialog" :edited-item="editedItem" @success="load" />
    <warehouse-doc-screen
      v-bind="docProps"
      :mobile="device.isMobile"
      @update:aggregate="aggregateMode = $event"
      @hint="setFiltersToLastEntry"
      @action="onDocAction"
      @open-row="openRowDoc"
      @toast="$emit('toast', $event)"
    >
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
      <template #detail-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabInvoice from "@/components/warehouse/tabs/WarehouseTabInvoice.vue";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";
import hasDocumentListScreen from "../../docs/hasDocumentListScreen";

/**
 * Izdavanje (otpremnice): lista dokumenata ili zbirni prikaz po artiklu, "Izdaj" u traci alata. Nasleđuje učitavanje,
 * filtriranje, brisanje, štampu, Excel i dijalog iz starog taba.
 */
export default {
  name: "WarehouseScreenInvoice",
  extends: WarehouseTabInvoice,
  mixins: [hasDocumentListScreen],
  components: { WarehouseDocScreen, WarehouseRowButton },
  computed: {
    docConfig() {
      return {
        icon: "mdi-receipt-text-arrow-right-outline",
        hintKey: "warehouse.last_invoice",
        emptyTitleKey: "no_invoices",
        emptyTextKey: "no_invoices_yet",
        dateLabel: this.$t("warehouse.waybill_date"),
        open: "editItem",
        remove: "deleteItem",
        run: "openWaybillDialog",
        action: { key: "release", label: this.$t("warehouse.release"), icon: "mdi-truck-delivery-outline", tone: "pri" },
      };
    },
  },
};
</script>
